const strings = {
  happy_womans_day: "Chúc mừng ngày phụ nữ",
  click_to_play: "Hí! Bấm vào tui nha!",
  from_author: "From Ringme with love! ❤️",
  label_gift_box: "Bấm để mở hộp quà nhé!"
}

const wishes = [
  "Chúc mừng ngày 20/10! Nhân ngày này, tôi muốn gửi đến các bạn nữ những lời chúc tốt đẹp nhất. Hãy luôn vui vẻ, thành công và xinh đẹp nhé!",
  "Bạn chính là một món quà đặc biệt không gì có thể thay thế được. Nhân dịp 20/10, chúc bạn tất cả những gì tốt đẹp nhất và luôn là chính mình nhé.",
  "Nhân dịp 20/10, chúc một nửa thế giới mãi xinh đẹp, hạnh phúc và thành công với những gì mình lựa chọn.",
  "Hôm nay là một ngày thật ý nghĩa. Hãy gác lại mọi công việc và tận hưởng nó nhé bạn của tôi. Chúc bạn có một ngày 20/10 tràn ngập niềm vui và hạnh phúc.",
  "Bạn luôn mang đến sự tích cực và vui vẻ cho mọi người. Mình thật vui vì chúng ta đã biết nhau và trở thành những người bạn thân thiết. 20/10 vui vẻ và hạnh phúc nhé.",
  "Ngày 20/10 là dịp để tôi gửi lời chúc tới tất cả bạn nữ thân yêu. Chúc các bạn nữ có một ngày thật nhiều niềm vui và tràn đầy hạnh phúc!",
  "Hôm nay là ngày của các bạn. Vì vậy, hãy tận hưởng nó, chúc các bạn nữ mãi xinh đẹp, rạng ngời và gặp nhiều may mắn trong cuộc sống.",
  "20/10 này tôi chúc các bạn nữ luôn luôn tươi trẻ, xinh đẹp, hạnh phúc và thành công hơn nữa để có thêm nhiều chàng trai theo đuổi như: như trời bám mây, như cây bám đất, lửa bám xăng, như răng bám lợi, như bít tất bám bàn chân…",
  "Thay mặt những người thường xuyên “mặc quần đùi”, chúc chị mãi khỏe như trâu, xinh như hoa và hạnh phúc tràn đầy nhé.",
  "Thay mặt cho hội hot boy đẹp trai, xin chúc chị em mau ăn chóng lớn, học tập tốt, lao động tốt để trở thành những người phụ nữ giỏi việc nước, đảm việc nhà nhé."
];

function get(key = "") {
  return strings[key];
}

function getRandomWish() {
  return wishes[Math.floor(Math.random() * (wishes.length - 1))]
}

const thingsToExport = {
  get,
  getRandomWish
};

export default thingsToExport